<template>
    <v-container fluid class="pa-4">
        <v-card elevation="1">
            <v-card class="ma-2">
                <v-card-title class="text-h5 gap-4 d-flex">
                    <v-col>
                        <v-row class="pb-2">
                            <v-icon left>
                                mdi-clipboard-list
                            </v-icon>
                            <strong>{{ assetData.name }}</strong> - Details
                        </v-row>
                        <v-row class="text-h6">
                            <v-chip
                            color="green"
                            class="text-subtitle-1"
                            >
                                <v-icon start size="14" class="me-1">mdi-circle</v-icon>
                                {{ assetData.asset_status?.name }}
                            </v-chip>
                        </v-row>
                    </v-col>
                    <v-col class="d-flex justify-end">
                        <qrcode-vue
                        v-if="qrCodeData"
                        :value="qrCodeData"  
                        :size="80"                          
                        level="H"
                        render-as="svg"
                        />
                    </v-col>    
                </v-card-title>
            </v-card>

            <v-row no-gutters>
                <v-col cols="12" md="3" lg="2" class="border-e">
                    <v-tabs
                    v-model="tab"
                    direction="vertical"
                    color="primary"
                    >
                        <v-tab 
                        v-for="(assetDetail, idx) in assetRegistrationTabList"
                        :key="idx"
                        :value="assetDetail.value" 
                        class="text-subtitle-2 font-weight-semibold">
                            <v-icon start>{{ assetDetail.icon }}</v-icon>
                            {{ assetDetail.title }}
                        </v-tab>
                    </v-tabs>
                </v-col>

                <v-col cols="12" md="9" lg="10">
                    <v-window v-model="tab">

                        <asset-registration-details 
                        :data="assetData"
                        />

                        <asset-register-components-records 
                        :componentsData="getAssetComponentsList"
                        :loading = "componentsLoading"
                        />

                        <asset-register-documents-records 
                        :documentsData="getAssetDocumentsList"
                        :loading = "documentsLoading"
                        />

                        <asset-register-assignments-records 
                        :assignmentsData="getAssetAssignmentsList"
                        :loading="assignmentsLoading"
                        />

                        <asset-register-depreciations-records
                        :depreciationsData="getAssetRegisterDepreciationsList"
                        :loading="depreciationLoading"
                        />

                        <asset-register-maintenances-records 
                        :maintainancesData="getAssetRegisterMaintenancesList"
                        :loading="maintenancesLoading"
                        />

                        <asset-register-preparations-records 
                        :preparationsData="getAssetRegisterPreparationsList"
                        :loading="preparationLoading"
                        />

                        <asset-register-transfers-records
                        :transfersData="getAssetRegisterTransfersList"
                        :loading="transfersLoading"
                        />

                        <asset-register-disposal-records 
                        :disposalsData="getAssetRegisterDisposalsList"
                        :loading="disposalsLoading"
                        />

                    </v-window>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

import assetRegistrationDetails from '@/components/module/asset/assetRegistration/assetRegistrationDetails/assetRegistrationDetails.vue';
import assetRegisterComponentsRecords from '@/components/module/asset/assetRegistration/assetRegisterComponents/assetReigisterComponentsRecords.vue';
import assetRegisterDocumentsRecords from '@/components/module/asset/assetRegistration/assetRegisterDocuments/assetRegisterDocumentsRecords.vue';
import assetRegisterAssignmentsRecords from '@/components/module/asset/assetRegistration/assetRegisterAssignments/assetRegisterAssignmentsRecords.vue';
import assetRegisterDepreciationsRecords from '@/components/module/asset/assetRegistration/assetRegisterDepreciations/assetRegisterDepreciationsRecords.vue';
import assetRegisterMaintenancesRecords from '@/components/module/asset/assetRegistration/assetRegisterMaintenances/assetRegisterMaintenancesRecords.vue';
import assetRegisterPreparationsRecords from '@/components/module/asset/assetRegistration/asssetRegisterPreparations/assetRegisterPreparationsRecords.vue';
import assetRegisterTransfersRecords from '@/components/module/asset/assetRegistration/assetRegisterTransfer/assetRegisterTransferRecords.vue';
import assetRegisterDisposalRecords  from "@/components/module/asset/assetRegistration/assetRegisterDisposals/assetRegisterDisposalRecords.vue";

export default {

    components: {
        QrcodeVue,
        assetRegistrationDetails,
        assetRegisterComponentsRecords,
        assetRegisterDocumentsRecords,
        assetRegisterAssignmentsRecords,
        assetRegisterDepreciationsRecords,
        assetRegisterMaintenancesRecords,
        assetRegisterPreparationsRecords,
        assetRegisterTransfersRecords,
        assetRegisterDisposalRecords,
    },

    data: () => ({
        tab :('details'),
        mainId: null,
        assetData : {},
        qrCodeData : null,

        assetRegistrationTabList: [
            { title: "Asset Details", icon: "mdi-information", value: "details" },
            { title: "Components", icon: "mdi-puzzle", value: "components" },
            { title: "Documents", icon: "mdi-file-document", value: "documents" },
            { title: "Depreciations", icon: "mdi-clock-out", value: "depreciations" },
            { title: "Preparations", icon: "mdi-clock-start", value: "preparations" },
            { title: "Transfers", icon: "mdi-transfer-right", value: "transfers" },
            { title: "Assigned To", icon: "mdi-clipboard-account", value: "assignments" },
            { title: "Maintenances", icon: "mdi-wrench", value: "maintenances" },
            { title: "Disposals", icon: "mdi-clock-end", value: "disposals" },
        ],

        componentsLoading: false,
        documentsLoading: false,
        assignmentsLoading: false,
        depreciationLoading: false,
        maintenancesLoading: false,
        preparationLoading:false,
        transfersLoading:false,
        disposalsLoading:false,
    }),

    watch: {
        tab(newVal, oldVal) {
            console.log("New Val",newVal);
            console.log("Old Val",oldVal);
            if(newVal === 'components' && this.$store.getters.getAssetComponentsList.length === 0) {
                this.componentsLoading = true,
                this.$store.dispatch("getAssetComponentsList", { asset_register_id : this.mainId})
                .then((response) => {
                    this.componentsLoading= false
                }).finally(() => {
                    this.componentsLoading= false
                })
            }

            if(newVal === 'documents' && this.$store.getters.getAssetDocumentsList.length === 0) {
                this.documentsLoading = true,
                this.$store.dispatch("getAssetDocumentsList", { asset_register_id : this.mainId})
                .then((response) => {
                    this.documentsLoading= false
                }).finally(() => {
                    this.documentsLoading= false
                })
            }

            if(newVal === 'assignments' && this.$store.getters.getAssetAssignmentsList.length === 0) {
                this.assignmentsLoading = true,
                this.$store.dispatch("getAssetAssignmentsList", { asset_register_id : this.mainId})
                .then((response) => {
                    this.assignmentsLoading= false
                }).finally(() => {
                    this.assignmentsLoading= false
                })
            }

            if(newVal === 'depreciations' && this.$store.getters.getAssetRegisterDepreciationsList.length === 0) {
                this.depreciationLoading = true,
                this.$store.dispatch("getAssetRegisterDepreciationsList", { asset_register_id : this.mainId})
                .then((response) => {
                    this.depreciationLoading= false
                }).finally(() => {
                    this.depreciationLoading= false
                })
            }

            if(newVal === 'maintenances' && this.$store.getters.getAssetRegisterMaintenancesList.length === 0) {
                this.maintenancesLoading = true,
                this.$store.dispatch("getAssetRegisterMaintenancesList", { asset_register_id : this.mainId})
                .then((response) => {
                    this.maintenancesLoading= false
                }).finally(() => {
                    this.maintenancesLoading= false
                })
            }

            if(newVal === 'preparations' && this.$store.getters.getAssetRegisterPreparationsList.length === 0) {
                this.preparationLoading = true,
                this.$store.dispatch("getAssetRegisterPreparationsList", { asset_register_id : this.mainId})
                .then((response) => {
                    this.preparationLoading= false
                }).finally(() => {
                    this.preparationLoading= false
                })
            }

            if(newVal === 'transfers' && this.$store.getters.getAssetRegisterTransfersList.length === 0) {
                this.transfersLoading = true,
                this.$store.dispatch("getAssetRegisterTransfersList", { asset_register_id : this.mainId})
                .then((response) => {
                    this.transfersLoading= false
                }).finally(() => {
                    this.transfersLoading= false
                })
            }

            if(newVal === 'disposals' && this.$store.getters.getAssetRegisterDisposalsList.length === 0) {
                this.disposalsLoading = true,
                this.$store.dispatch("getAssetRegisterDisposalsList", { asset_register_id : this.mainId})
                .then((response) => {
                    this.disposalsLoading= false
                }).finally(() => {
                    this.disposalsLoading= false
                })
            }
        },

        assetData(val   ) {
            this.qrCodeData = `Name: ${val.name}\nCode: ${val.code}`;
        },
    },
    
    created() {
        const id = this.$route.params.id;
        this.mainId = id;
        this.$store.dispatch("getAssetRegistrationById", id).then((response)=> {
            this.assetData = response.data;
        })
    },

    computed: {
        getAssetComponentsList() {
            const AssetComponentList = this.$store.getters.getAssetComponentsList;
            return AssetComponentList;
        },

        getAssetDocumentsList() {
            const AssetDocumentList = this.$store.getters.getAssetDocumentsList;
            return AssetDocumentList;
        },

        getAssetAssignmentsList() {
            const AssetAssignmentList = this.$store.getters.getAssetAssignmentsList;
            return AssetAssignmentList;
        },

        getAssetRegisterDepreciationsList() {
            const AssetRegisterDepreciationList = this.$store.getters.getAssetRegisterDepreciationsList;
            return AssetRegisterDepreciationList;
        },

        getAssetRegisterMaintenancesList() {
            const AssetRegisterMaintenanceList = this.$store.getters.getAssetRegisterMaintenancesList;
            return AssetRegisterMaintenanceList;
        },
        
        getAssetRegisterPreparationsList() {
            const AssetRegisterPreparationList = this.$store.getters.getAssetRegisterPreparationsList;
            return AssetRegisterPreparationList;
        },

        getAssetRegisterTransfersList() {
            const AssetRegisterTranfersList = this.$store.getters.getAssetRegisterTransfersList;
            return AssetRegisterTranfersList;
        },

        getAssetRegisterDisposalsList() {
            const AssetRegisterDisposalsList = this.$store.getters.getAssetRegisterDisposalsList;
            return AssetRegisterDisposalsList;
        }
    },

    methods: {},
    setup() {},
    mounted() {},  
    beforeUnmount() {

        const unsetMutationsTypes = [
            "UNSET_ASSET_COMPONENTS_LIST",
            "UNSET_ASSET_DOCUMENTS_LIST",
            "UNSET_ASSET_ASSIGNMENTS_LIST",
            "UNSET_ASSET_REGISTER_DEPRECIATION_LIST",
            "UNSET_ASSET_REGISTER_PREPARATION_LIST",
            "UNSET_ASSET_REGISTER_TRANSFER_LIST",
            "UNSET_ASSET_REGISTER_DISPOSAL_LIST",
        ]

        unsetMutationsTypes.forEach((mutations) => {
            this.$store.commit(mutations);
        })
            
    }
}

</script>

<style scoped>
.border-e {
    border-right: 1px solid rgba(0, 0, 0, 0.12);
}

:deep(.v-tab.v-tab--selected .v-icon) {
    color: #1867C0 !important; 
}

:deep(.v-tab.v-tab--selected) {
    color: black !important; 
    background-color: #E4F2FD;
    border-right: 2px solid #1867C0 !important; 
    border-left: none !important; 
}

:deep(.v-tab) {
    height: 36px !important;
    padding: 7px 16px !important;
    text-transform: none !important;
    letter-spacing: normal !important;
    justify-content: flex-start !important;
    border-left: none !important; 
}

:deep(.v-tabs .v-slide-group__content) {
    border-left: none !important;
}

:deep(.v-tab__slider) {
    display: none !important; 
}
</style>